module.exports = __webpack_public_path__ + "static/media/Water_Bath.9d68a05f.svg";